"use client";

import { usePathname } from "next/navigation";
import { Menu, X } from "lucide-react";
import { useEffect, useRef } from "react";

/**
 * Mobil menü çekmecesi — KASITLI OLARAK ÇOK KÜÇÜK bir istemci bileşeni.
 *
 * Menünün içeriği (kategoriler, 111 araç bağlantısı) sunucuda üretilir ve
 * buraya children olarak gelir; bu bileşen o işaretlemeyi hidrate etmez.
 * Daha önce tüm header istemci bileşeniydi ve araç kataloğunu (~104 KB)
 * her sayfaya taşıyıp 1238 düğümü hidrate ediyordu.
 *
 * Aç/kapa işini native <details> yapar, JavaScript gerekmez. Buradaki tek
 * iş: sayfa değişince çekmeceyi kapatmak. Next.js'te gezinme sayfayı
 * yeniden kurmadığı için <details> açık kalırdı.
 */
export function MobilMenu({ children }: { children: React.ReactNode }) {
  const ref = useRef<HTMLDetailsElement>(null);
  const yol = usePathname();

  useEffect(() => {
    if (ref.current) ref.current.open = false;
  }, [yol]);

  return (
    <details ref={ref} className="group/menu xl:hidden">
      <summary
        aria-label="Menü"
        className="grid size-9 cursor-pointer list-none place-items-center rounded-lg border border-border text-muted [&::-webkit-details-marker]:hidden"
      >
        <Menu className="size-4 group-open/menu:hidden" />
        <X className="hidden size-4 group-open/menu:block" />
      </summary>

      <div className="absolute inset-x-0 top-full max-h-[80vh] overflow-y-auto border-t border-border bg-surface">
        {children}
      </div>
    </details>
  );
}
